<template>
    <div class="tabs">
        <div v-for="tab in tabList" :key="tab.key" class="tab" :class="getTabClass(tab)" @click="OpenTab(tab.key)">
            {{ tab.label }}
            <span v-if="tab.tooltip" class="tab-tooltip">{{ tab.tooltip }}</span>
        </div>
    </div>
</template>

<script>
    const TabEnum = Object.freeze({
        VIEW: 'view',
        UPLOAD: 'upload',
        SUMMARY: 'summary',
    })

    export default {
        props: {
            activeTab: {
                type: String,
                default: TabEnum.VIEW,
            },
        },
        data() {
            return {
                TabEnum,
            }
        },
        computed: {
            tabList() {
                return [
                    {
                        key: TabEnum.VIEW,
                        label: this.$t('modals.patient_profile.profile.detail_form.tabs.view'),
                    },
                    {
                        key: TabEnum.UPLOAD,
                        label: this.$t('modals.patient_profile.profile.detail_form.tabs.upload'),
                    },
                    {
                        key: TabEnum.SUMMARY,
                        label: this.$t('modals.patient.tab.label_four'),
                        disabled: true,
                        tooltip: this.$t('modals.patient.feature_coming_soon'),
                    },
                ]
            },
        },
        methods: {
            getTabClass(tab) {
                return {
                    active: this.activeTab === tab.key,
                    'disabled-tab': !!tab.disabled,
                }
            },
            OpenTab(name) {
                if (name === TabEnum.SUMMARY) {
                    return
                }
                this.$emit('toggle', name)
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    .tabs {
        display: flex;
        justify-content: space-around;
        margin-bottom: 15px;
        background: #e4e0e0;
        border-radius: 20px;
    }
    .tab {
        flex: 1;
        text-align: center;
        padding: 5px;
        cursor: pointer;
        color: black;
        font-size: 12px;
        margin: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 500;
        position: relative;

        &:hover .tab-tooltip {
            visibility: visible;
            opacity: 1;
            transform: translateX(-50%) scale(1);
        }
    }
    .tab.active {
        background: white;
        font-weight: 500;
        border-radius: 32px;
        font-size: 13px;
        color: black;
        font-weight: 500;
    }
    @media screen and (max-width: 600px) {
        .tab,
        .tab.active {
            font-size: 10px;
        }
    }
    .disabled-tab {
        cursor: not-allowed !important;
        color: #94a3b8 !important;

        &:hover {
            background: transparent !important;
            color: #94a3b8 !important;
        }
    }
    .tab-tooltip {
        visibility: hidden;
        opacity: 0;
        position: absolute;
        bottom: calc(100% + 8px);
        left: 50%;
        transform: translateX(-50%) scale(0.95);
        background-color: #1e293b;
        color: #f8fafc;
        padding: 6px 12px;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 400;
        white-space: nowrap;
        pointer-events: none;
        transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s ease;
        z-index: 1000;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
        line-height: normal;

        &::after {
            content: '';
            position: absolute;
            top: 100%;
            left: 50%;
            margin-left: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: #1e293b transparent transparent transparent;
        }
    }
</style>
